var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'app--printmode': _vm.printMode },attrs:{"id":"app"}},[_c('router-view'),_c('canvas',{ref:"app__canvas-confetti",staticClass:"app__canvas-confetti"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }